import { Component, inject, PLATFORM_ID } from '@angular/core';
import { RouterLink } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-footer',
  imports: [RouterLink],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  private platformId = inject(PLATFORM_ID);

  navigateToInstagram() {
    if (isPlatformBrowser(this.platformId)) {
      window.open('https://www.instagram.com/drazamed_colombia', '_blank');
    }
  }

  navigateToFacebook() {
    if (isPlatformBrowser(this.platformId)) {
      window.open('https://www.facebook.com/profile.php?id=100058908593400', '_blank');
    }
  }
}
